import { useState } from 'react';
import { useCartStore } from '../../store/cartStore';
import { formatCurrency } from '../../utils/helpers';
import { Button } from '../../components/ui/Button';

export const POS = () => {
  const { items, addItem, removeItem, updateQuantity, clearCart, getTotal } = useCartStore();
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleAddItem = (product) => {
    addItem(product);
  };

  const total = getTotal();
  const gst = (total * 18) / 100;
  const grandTotal = total + gst;

  return (
    <div className="grid grid-cols-3 gap-6 h-[calc(100vh-200px)]">
      {/* Products Section */}
      <div className="col-span-2 overflow-auto">
        <div className="mb-4">
          <h2 className="text-2xl font-bold mb-4">Products</h2>
          <input
              type="text"
              placeholder="Search products..."
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            {/* TODO: Fetch and display products */}
            <p className="text-gray-500">Products loading...</p>
          </div>
        </div>

        {/* Cart Section */}
        <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col">
          <h2 className="text-2xl font-bold mb-4">Cart</h2>
          
          <div className="flex-1 overflow-auto mb-4">
            {items.length === 0 ? (
              <p className="text-gray-500 text-center py-8">Cart is empty</p>
            ) : (
              <div className="space-y-3">
                {items.map(item => (
                  <div key={item.id} className="flex justify-between items-center bg-gray-50 p-3 rounded">
                    <div>
                      <p className="font-medium text-sm">{item.name}</p>
                      <p className="text-xs text-gray-500">{formatCurrency(item.price)}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        min="1"
                        value={item.quantity}
                        onChange={(e) => updateQuantity(item.id, parseInt(e.target.value))}
                        className="w-12 px-2 py-1 border rounded text-sm"
                      />
                      <button
                        onClick={() => removeItem(item.id)}
                        className="text-red-600 hover:text-red-800 text-sm"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Totals */}
          <div className="border-t pt-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span>Subtotal:</span>
              <span>{formatCurrency(total)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span>GST (18%):</span>
              <span>{formatCurrency(gst)}</span>
            </div>
            <div className="flex justify-between font-bold text-lg border-t pt-2">
              <span>Total:</span>
              <span>{formatCurrency(grandTotal)}</span>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-2 mt-4">
            <Button className="w-full bg-green-600 hover:bg-green-700">
              Checkout
            </Button>
            <Button 
              variant="secondary" 
              className="w-full"
              onClick={clearCart}
            >
              Clear Cart
            </Button>
          </div>
        </div>
      </div>
  );
};
